(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/store/teams-slice.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/store/teams-slice.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  processTeam
} = svs.arena.helpers.teamHelpers;
const {
  memberStates
} = svs.arena.constants;
const {
  getTeamsAsync,
  getTeamAsync,
  getInvitationlinkAsync,
  postInvitationlinkAsync,
  getPlayerId
} = svs.arena.service.teamsService;
const findTeamById = (state, teamId) => state.teams.find(team => team.syndicateId === teamId);
const findTeamDetailsById = (state, teamId) => state.teamDetails.find(team => team.syndicateId === teamId);
const getActiveMemberCount = teamDetails => teamDetails.members.filter(member => member.memberState === memberStates.ACTIVE).length;
const fetchCustomerId = RTK.createAsyncThunk('arena/fetchCustomerId', async (_, _ref) => {
  let {
    getState,
    rejectWithValue
  } = _ref;
  const teamsState = getState().teams;
  if (teamsState.customerId) {
    return {
      status: 'success',
      error: null,
      data: teamsState.customerId
    };
  }
  const {
    error,
    data
  } = await getPlayerId();
  if (error) {
    rejectWithValue(error);
  }
  return {
    status: 'success',
    error: null,
    data
  };
});
const fetchTeams = RTK.createAsyncThunk('arena/fetchteams', async (_, _ref2) => {
  let {
    rejectWithValue
  } = _ref2;
  try {
    const response = await getTeamsAsync();
    if (!response || response !== null && response !== void 0 && response.error) {
      return rejectWithValue({
        error: response.error.code
      });
    }
    const data = response.data.map(team => processTeam(team));
    return {
      status: 'success',
      error: null,
      data
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});
const getInviteId = async teamId => {
  let invite = {};
  let error;
  const response = await getInvitationlinkAsync(teamId);
  svs.arena.logger.debug('*** redux, teams, fetchTeamInviteId, getInvitationlinkAsync, response: ', response);
  if (response && response !== null && response !== void 0 && response.data) {
    var _response$data$syndic;
    const invitationInfo = (_response$data$syndic = response.data.syndicate) === null || _response$data$syndic === void 0 ? void 0 : _response$data$syndic.invitationInfo;
    if (invitationInfo) {
      var _response$data$syndic2, _response$data$syndic3;
      invite = {
        teamId: (_response$data$syndic2 = response.data.syndicate) === null || _response$data$syndic2 === void 0 || (_response$data$syndic2 = _response$data$syndic2.invitationInfo) === null || _response$data$syndic2 === void 0 ? void 0 : _response$data$syndic2.syndicateId,
        linkId: (_response$data$syndic3 = response.data.syndicate) === null || _response$data$syndic3 === void 0 || (_response$data$syndic3 = _response$data$syndic3.invitationInfo) === null || _response$data$syndic3 === void 0 ? void 0 : _response$data$syndic3.invitationToken,
        validTo: response.data.syndicate.invitationInfo.validUntil
      };
    }
  } else if (response && (response === null || response === void 0 ? void 0 : response.errorCode) === 2) {
    svs.arena.logger.debug('*** redux, teams, fetchTeamInviteId, No token fond in backend syn, create new....');
    const responsePost = await postInvitationlinkAsync(teamId);
    svs.arena.logger.debug('*** redux, teams, fetchTeamInviteId, No token fond in backend syn, got responsePost: ', responsePost);
    if (!responsePost || responsePost !== null && responsePost !== void 0 && responsePost.errorCode) {
      return {
        error: responsePost.errorCode
      };
    }
    invite = {
      teamId,
      linkId: responsePost.data.invitationToken,
      validTo: responsePost.data.validUntil
    };
  } else if (!response || response !== null && response !== void 0 && response.errorCode) {
    return {
      error: response.errorCode
    };
  }
  return {
    invite,
    error
  };
};
const fetchTeamsInviteId = RTK.createAsyncThunk('arena/fetchteamsinviteid', async (_, _ref3) => {
  let {
    getState,
    rejectWithValue
  } = _ref3;
  try {
    const teamsState = getState().teams;
    svs.arena.logger.debug('***** redux, teams, fetchTeamsInviteId...teamsState: ', teamsState);
    const teamInviteIds = teamsState.inviteIds || [];
    const fetchedInvetIds = [];
    svs.arena.logger.debug('teamsState: ', teamsState);
    if (teamsState.teams) {
      for (const team of teamsState.teams) {
        if (team.isLeader) {
          svs.arena.logger.debug('--- teamId: ', team.syndicateId);
          const id = teamInviteIds.find(item => item.teamId === team.syndicateId);
          if (id === undefined) {
            const {
              invite,
              error
            } = await getInviteId(team.syndicateId);
            svs.arena.logger.debug('*** redux, teams, teamsState.teams.forEach((team).team.syndicateId (get Id for team):', team.syndicateId, invite, error);
            if (invite && !error) {
              fetchedInvetIds.push(invite);
            }
          } else {
            svs.arena.logger.debug('*** redux, teams, teamsState.teams.forEach((team).team.syndicateId (found Id copy it):', team.syndicateId);
            fetchedInvetIds.push(id);
          }
        }
      }
    }
    svs.arena.logger.debug('*** redux, teams, fetchTeamInviteId, fetchedInvetIds...', fetchedInvetIds);
    return {
      status: 'success',
      error: null,
      data: fetchedInvetIds
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});
const createTeamInviteId = RTK.createAsyncThunk('arena/createTeamInviteId', async (inviteData, _ref4) => {
  let {
    rejectWithValue
  } = _ref4;
  try {
    svs.arena.logger.debug('*** redux, teams, createTeamInviteId...teamId, initialDeposit: ', inviteData === null || inviteData === void 0 ? void 0 : inviteData.teamId, inviteData === null || inviteData === void 0 ? void 0 : inviteData.initialDeposit);
    const {
      data,
      teamId,
      error
    } = await postInvitationlinkAsync(inviteData === null || inviteData === void 0 ? void 0 : inviteData.teamId, inviteData === null || inviteData === void 0 ? void 0 : inviteData.initialDeposit);
    if (error) {
      return rejectWithValue({
        error
      });
    }
    svs.arena.logger.debug('*** redux, teams, createTeamInviteId, invite:', data);
    return {
      status: 'success',
      error: null,
      data,
      teamId
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});
const fetchTeamInviteId = RTK.createAsyncThunk('arena/fetchteaminviteid', async (id, _ref5) => {
  let {
    rejectWithValue
  } = _ref5;
  try {
    svs.arena.logger.debug('*** redux, teams, fetchTeamInviteId...');
    const {
      invite,
      error
    } = await getInviteId(id);
    if (error) {
      return rejectWithValue({
        error
      });
    }
    svs.arena.logger.debug('*** redux, teams, fetchTeamInviteId, invite:', invite);
    const data = invite;
    return {
      status: 'success',
      error: null,
      data
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});
const fetchTeamsDetails = RTK.createAsyncThunk('arena/fetchteamsdetails', async (_, _ref6) => {
  let {
    getState,
    rejectWithValue
  } = _ref6;
  try {
    const teamsState = getState().teams;
    svs.arena.logger.debug('***** redux, teams, fetchTeamsDetails...teamsState: ', teamsState);
    const teamDetails = teamsState.teamDetails || [];
    const fetchedTeamDetails = [];
    for (const team of teamsState.teams) {
      const id = teamDetails.find(item => item.syndicateId === team.syndicateId);
      svs.arena.logger.debug('***** redux, teams, fetchTeamsDetails...teamDetails.find: ', id);
      if (id === undefined) {
        const response = await getTeamAsync(team.syndicateId);
        if (!response || response !== null && response !== void 0 && response.error) {
          return rejectWithValue({
            error: response.error.code
          });
        }
        fetchedTeamDetails.push(response.data);
      } else {
        svs.arena.logger.debug('*** redux, teams, fetchTeamsDetails (found Id copy it, for teamId):', team.syndicateId);
        fetchedTeamDetails.push(id);
      }
    }
    svs.arena.logger.debug('*** redux, teams, fetchTeamsDetails (for-loop ready) fetchedTeamDetails:', fetchedTeamDetails);
    return {
      status: 'success',
      error: null,
      data: fetchedTeamDetails
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});
const fetchTeamDetails = RTK.createAsyncThunk('arena/fetchteamdetails', async (id, _ref7) => {
  let {
    rejectWithValue
  } = _ref7;
  try {
    const response = await getTeamAsync(id);
    if (!response || response !== null && response !== void 0 && response.error) {
      return rejectWithValue({
        error: response.error.code
      });
    }
    const data = processTeam(response.data);
    return {
      status: 'success',
      error: null,
      data
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});
const fetchProducts = RTK.createAsyncThunk('arena/fetchProducts', async (_, _ref8) => {
  let {
    rejectWithValue
  } = _ref8;
  try {
    const draws = await svs.arena.service.drawsService.fetchDrawsAsync();
    if (!draws || draws !== null && draws !== void 0 && draws.error) {
      return rejectWithValue({
        error: draws.error.code
      });
    }
    const data = await svs.arena.service.drawsProcesser.parseResponses(draws);
    return {
      status: 'success',
      error: null,
      data
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});

const getInitialState = () => ({
  teams: [],
  teamDetails: [],
  inviteIds: [],
  products: {},
  transactions: {},
  latestFetch: 0,
  error: null
});
const teamsSlice = RTK.createSlice({
  name: 'teams',
  initialState: getInitialState(),
  reducers: {
    setTeamBalance: (state, action) => {
      const {
        teamId,
        memberBalance,
        playableAmount,
        syndicateBalance,
        customerId,
        isMemberActive = true
      } = action.payload;
      const team = findTeamById(state, teamId);
      if (team) {
        if (playableAmount !== undefined) {
          team.playableAmount = playableAmount;
        }
        if (memberBalance !== undefined) {
          team.memberBalance = memberBalance;
        }
        if (syndicateBalance !== undefined) {
          team.totalSyndicateBalance = syndicateBalance;
        }
      }
      if (isMemberActive) {
        const teamDetail = findTeamDetailsById(state, teamId);
        if (teamDetail) {
          let member;
          if (customerId) {
            member = teamDetail.members.find(m => m.customerId === customerId);
          } else {
            member = teamDetail.members.find(m => m.isCurrentMember === true);
          }
          member.memberBalance = memberBalance || svs.utils.format.CurrencyAsJupiterString(0);
        }
      }
    },
    changeMemberActivity: (state, action) => {
      const {
        teamId,
        customerId,
        active
      } = action.payload;
      const teamDetails = findTeamDetailsById(state, teamId);
      const team = findTeamById(state, teamId);
      teamDetails.members.forEach(member => {
        if (member.customerId === customerId) {
          member.memberState = active ? memberStates.ACTIVE : memberStates.INACTIVE;
          team.activeMemberCount = getActiveMemberCount(teamDetails);
          teamDetails.activeMemberCount = getActiveMemberCount(teamDetails);
        }
        const tooFewMembers = getActiveMemberCount(teamDetails) < 2;
        team.tooFewMembers = tooFewMembers;
        teamDetails.tooFewMembers = tooFewMembers;
      });
    },
    removeInvitee: (state, action) => {
      const {
        invitationId,
        teamId
      } = action.payload;
      const teamDetails = findTeamDetailsById(state, teamId);
      teamDetails.pendingInvitations.invitations = teamDetails.pendingInvitations.invitations.filter(invitee => invitee.invitationId !== invitationId);
      teamDetails.pendingInvitations.numberofInvitations = teamDetails.pendingInvitations.invitations.length;
    },
    removeMember: (state, action) => {
      const {
        customerId,
        teamId
      } = action.payload;
      const team = findTeamById(state, teamId);
      const teamDetails = findTeamDetailsById(state, teamId);
      teamDetails.members = teamDetails.members.filter(member => member.customerId !== customerId);
      const activeMemberCount = getActiveMemberCount(teamDetails);
      teamDetails.activeMemberCount = activeMemberCount;
      team.activeMemberCount = activeMemberCount;
      const fullMemberCount = teamDetails.members.length;
      team.fullMemberCount = fullMemberCount;
      teamDetails.fullMemberCount = fullMemberCount;
      const tooFewMembers = activeMemberCount < 2;
      team.tooFewMembers = tooFewMembers;
      teamDetails.tooFewMembers = tooFewMembers;
    },
    removeTeam: (state, action) => {
      const teamId = action.payload;
      state.teams = state.teams.filter(_ref9 => {
        let {
          syndicateId
        } = _ref9;
        return teamId !== syndicateId;
      });
      state.teamDetails = state.teamDetails.filter(_ref10 => {
        let {
          syndicateId
        } = _ref10;
        return teamId !== syndicateId;
      });
      state.inviteIds = state.inviteIds.filter(invite => invite.teamId !== teamId);
    },
    changeMemberRole: (state, action) => {
      const {
        teamId,
        customerId,
        memberRole
      } = action.payload;
      const teamDetails = findTeamDetailsById(state, teamId);
      teamDetails.members.forEach(member => {
        if (member.customerId === customerId) {
          member.memberRole = memberRole;
        }
      });
    },
    updateMemberBalance: (state, action) => {
      const {
        teamId,
        memberBalance
      } = action.payload;
      const teamDetails = findTeamDetailsById(state, teamId);
      const currentMember = teamDetails.members.find(_ref11 => {
        let {
          isCurrentMember
        } = _ref11;
        return isCurrentMember;
      });
      currentMember.memberBalance = memberBalance;
    }
  },
  extraReducers(builder) {
    builder.addCase(fetchTeams.fulfilled, (state, action) => {
      state.teams = action.payload.data;
      state.latestFetch = new Date().getTime();
      state.error = action.payload.error;
    }).addCase(fetchTeamsInviteId.fulfilled, (state, action) => {
      const inviteData = action.payload.data;
      svs.arena.logger.debug('*** redux, fetchTeamsInviteId.fulfilled, inviteData: ', inviteData);
      state.inviteIds = inviteData;
    }).addCase(fetchTeamInviteId.fulfilled, (state, action) => {
      const inviteData = action.payload.data;
      const pos = state.inviteIds.findIndex(invite => invite.teamId === inviteData.teamId);
      if (pos === -1) {
        state.inviteIds = [...state.inviteIds, inviteData];
      } else {
        const allOthers = state.inviteIds.filter(item => item.teamId !== inviteData.teamId);
        state.inviteIds = [...allOthers, inviteData];
      }
    }).addCase(createTeamInviteId.fulfilled, (state, action) => {
      const inviteData = action.payload.data;
      const teamId = action.payload.teamId;
      const invite = {
        teamId,
        validTo: inviteData.validUntil,
        linkId: inviteData.invitationToken
      };
      svs.arena.logger.debug('*** redux, createTeamInviteId.fulfilled, invite: ', invite);
      const allOthers = state.inviteIds.filter(item => item.teamId !== teamId);
      state.inviteIds = [...allOthers, invite];
    }).addCase(fetchTeamsDetails.fulfilled, (state, action) => {
      const teamsDetails = action.payload.data;
      svs.arena.logger.debug('*** redux, fetchTeamsDetails.fulfilled, teamsDetails: ', teamsDetails);
      state.teamDetails = teamsDetails;
    }).addCase(fetchTeamsDetails.rejected, (state, action) => {
      svs.arena.logger.info('*** redux, fetchTeamsDetails.rejected, teamsDetails: ', action.payload);
    }).addCase(fetchTeamDetails.fulfilled, (state, action) => {
      const teamId = action.payload.data.syndicateId;
      const newTeamDetailsArray = [...state.teamDetails.filter(team => team.syndicateId !== teamId), action.payload.data];
      state.teamDetails = newTeamDetailsArray;
    }).addCase(fetchProducts.fulfilled, (state, action) => {
      state.products = {};
      state.products.products = action.payload.data;
      state.products.loadingError = action.payload.error;
    }).addCase(fetchCustomerId.fulfilled, (state, action) => {
      state.customerId = action.payload.data;
    });
  }
});
svs.arena.store.teams = svs.arena.store.teams || {};
svs.arena.store.teams.actions = _objectSpread({
  fetchTeams,
  fetchTeamInviteId,
  fetchTeamsInviteId,
  createTeamInviteId,
  fetchTeamDetails,
  fetchTeamsDetails,
  fetchProducts,
  fetchCustomerId
}, teamsSlice.actions);
svs.arena.store.teams.reducer = teamsSlice.reducer;
svs.arena.store.teams.initialState = getInitialState();

 })(window);